import { render } from "./BaseThemeToggle.vue?vue&type=template&id=cd5bec08&scoped=true"
import script from "./BaseThemeToggle.vue?vue&type=script&lang=js"
export * from "./BaseThemeToggle.vue?vue&type=script&lang=js"

import "./BaseThemeToggle.vue?vue&type=style&index=0&id=cd5bec08&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5bec08"]])

export default __exports__